<template>
    <div class="pwa-update">
        <div class="bg-container">
            <img class="bg" :src="getThemeImg('pwa-dialog/bg.png')" alt="" />
            <!-- 内容区域 -->
            <div class="pwa-update-content overflow-y-auto overscroll-none">
                <p v-html="userinfo?.toGoogleContent"></p>
            </div>
            <!-- 按钮 -->
            <div class="btn-container" @click="handleButtonClick" @mousedown="handleButtonPress" @mouseup="handleButtonRelease" @touchstart="handleButtonPress" @touchend="handleButtonRelease">
                <img ref="btnRef" class="btn-image transition-transform duration-100" :src="getThemeImg('pwa-dialog/btn.png')" alt="确认按钮" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import useApp from 'core/hooks/useApp';
import { ref, computed } from 'vue';
import useImage from 'core/hooks/useImage';

const { userStore } = useApp();
const userinfo = computed(() => userStore.GetUserInfo);
const { getThemeImg } = useImage();
const btnRef = ref<HTMLImageElement | null>(null);

const emit = defineEmits(['click']);

function handleButtonPress() {
    if (btnRef.value) {
        btnRef.value.style.transform = 'scale(0.9)';
    }
}

function handleButtonRelease() {
    if (btnRef.value) {
        btnRef.value.style.transform = 'scale(1)';
    }
}

function handleButtonClick() {
    emit('click');
}
</script>

<style scoped lang="scss">
.pwa-update {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .bg-container {
        position: relative;
        width: 100%;
        max-width: 100vw;
        max-height: 100vh;
    }

    .bg {
        width: 100%;
        height: auto;
        display: block;
    }

    .pwa-update-content {
        position: absolute;
        width: 64%;
        height: 20%;
        left: 18%;
        top: 50%;
        transform-origin: center center;
    }

    .btn-container {
        position: absolute;
        bottom: 8%;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
    }

    .btn-image {
        width: auto;
        height: auto;
        max-width: 50vw;
    }
}
</style>
